import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';
import { getAwinConversionPayload } from '../affiliate-marketing-handlers/index';
const channelInfo = SiteUtilities.channelInfo();

let emailOld = ''; // fservice spam check
let uidOld = '';

const loadGtmScriptsOnSignupCompletionAsync = (thankYouRedirect) => {
  SiteUtilities.historyPushState(thankYouRedirect, false);

  // Below GTM script should run only for English.
  const lang = jQuery('body').data('lang');
  if (lang !== 'en') {
    return jQuery.Deferred().resolve();
  }

  window.dataLayer = window.dataLayer || [];
  function gtag () { window.dataLayer.push(arguments); }

  const initializeGoogleAnalytics = (id) => {
    gtag('js', new Date());
    gtag('config', id);
  };

  const trackConversions = () => {
    gtag('event', 'conversion', {
      send_to: 'AW-978679283/9-tzCOWmyAcQ8-vV0gM',
      value: 1.0,
      currency: 'USD'
    });
  };

  // Create an array of script URLs to load in parallel
  const scriptUrls = [
    'https://www.googletagmanager.com/gtag/js?id=AW-978679283'
  ];

  return Promise.all(scriptUrls.map(SiteUtilities.loadScriptWithPromise))
    .then(() => {
      initializeGoogleAnalytics('AW-978679283');
      trackConversions();
    })
    .catch(error => {
      SiteUtilities.log(
        'Error in loadGtmScriptsOnSignupCompletionAsync',
        'error',
        'fservice-form-handlers.js',
        1,
        error
      );
    });
};

// Fetch language value to be passed along with request payload
const getSignupEndpointLang = (workflowLocale) => {
  return {
    de: 'de',
    fr: 'fr',
    es: 'es',
    pt: 'pt-BR',
    'latam-es': 'es-LA',
    nl: 'nl',
    'sv-SE': 'sv-SE',
    ja: 'ja-JP',
    en: 'en'
  }[workflowLocale];
};

// Freshservice signup
const fserviceSignupForm = (classname, form) => {
  SiteUtilities.resetSignupPerformanceLog();
  localStorage.setItem('signupStartTime', new Date().toISOString());
  const $form = $(form);
  const maxmindObj = LocationUtilities.getGeoLocation();
  const country = maxmindObj ? maxmindObj.countryName : '';
  const signUpApiUrl = $form.data('signup-url') || 'https://signup.freshservice.com/accounts/new_signup_free';
  const spamCheckUrl = $form.data('spam-check-url') || 'https://alfred.freshworks.com/v1/robin';
  const postData = [];
  let spamData = {};
  let redirectUrl = '#';
  let currentLoc = '';
  const signUpBtn = $form.find('input.button');
  const redirect = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect'));
  const redirectSpam = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect-spam'));
  const phoneNumber = $form.find('input[name^="phone"]').val();
  const phoneCheck = $form.attr('data-phone-check');
  const isNumberGiven = localStorage.getItem('number_given') || false;
  const isParentModal = $form.attr('data-parent-modal') === 'yes';
  const expressModalShown = localStorage.getItem('expressModalShown') || false;
  const parentModalId = $form.attr('data-parent-modal-id') || null;
  const emailid = $form.find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const currentLang = $('body').attr('data-lang');
  const $domainField = $form.find('.domain-form');
  const $miscPayload = $form.find('.aloha-misc-payload');
  const firstName = $form.find('.first-name-form').val();
  const lastName = $form.find('.last-name-form').val();
  const company = $form.find('.company-form').val();

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(emailid, fmAssetId, tacticId);
  const gclid = SiteUtilities.getGclId();
  const utmMedium = SiteUtilities.getUtmMedium();
  const isFormPrefilled = sessionStorage.getItem('initial_form_details') === localStorage.getItem('form_details');

  if (sessionStorage.getItem('isPrefilledForm') !== 'false') {
    sessionStorage.setItem('isPrefilledForm', isFormPrefilled.toString());
  }
  SiteUtilities.storeSignupInitialLog();
  const signupFlow = () => {
    /*
    * UID is used for spamscore validation from backend and email
    * service team UID generated from site-utilities.js file.
    */
    let uid = SiteUtilities.generateUID();

    // Dynamically append backend error wrapper
    $form.find('.company-form').siblings('.error-wrapper').after(`<div class="backend-error-wrapper"></div>`);
    $form.find('.backend-fail-note').remove();

    // Populate hidden fields with cookie info
    signUpBtn.addClass('button--loading').attr('disabled', 'disabled');
    $form.find('input[name^="first_referrer"]').val((Cookie.get('fw_fr') || currentLoc));
    $form.find('input[name^="first_landing_url"]').val((Cookie.get('fw_flu') || ''));

    // Remove backend domain error messages when user interacts with input elements
    $form.find('.form-field .domain-form, .form-field .company-form, .form-field .phone-form').one('change keypress keyup keydown focus', function () {
      $form.find('.backend-error-wrapper').fadeOut('fast', 'swing').empty();
      $form.find('.form-field-domain').removeClass('error');
      signUpBtn.removeAttr('disabled');
    });
    const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
    if (sessionObj) {
      sessionObj.composite_stitching_key = compositeKey;
      sessionObj.allocadia_asset_id = fmAssetId;
      sessionObj.allocadia_tactic_id = tacticId;

      sessionObj.ga_client_id = SiteUtilities.getCombinedGaClientId(gclid, compositeKey);
    }
    // Binding maxmind_session
    sessionObj.location = LocationUtilities.getGeoLocation();
    currentLoc = (sessionObj && sessionObj.original_session) ? sessionObj.original_session.referrer : SiteUtilities.getCurrentLocation();
    if (currentReferrer && isExternalIframeSignup) {
      currentLoc = currentReferrer;
      sessionObj.current_session.url = `${SiteUtilities.getCurrentLocation()}?first_referrer=${currentReferrer}`;
    }
    if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
      const { simpleGeoLocation: { countryCode, countryName, country: { iso_code: isoCode } = {} } = {} } = sessionObj || {};
      if (sessionObj) {
        sessionObj.location = {
          country: {
            iso_code: isoCode || ''
          },
          ipAddress: '',
          countryCode: countryCode || '',
          countryName: countryName || ''
        };
        sessionObj.simpleGeoLocation = sessionObj.location;
        sessionObj.geoLocation = sessionObj.location;
      }
    }

    if (sessionObj) {
      // attach Google click ID (gclid) in sessionObj
      sessionObj.gclid = gclid;
    }

    const sessionJSON = sessionObj ? JSON.stringify(sessionObj) : null;

    // Bind username and fs_cookie
    let fsCookie = '';
    try {
      fsCookie = freshsales.anonymous_id;
    } catch (exception) {
      SiteUtilities.log(
        'Freshservice session exception.',
        'warning',
        'submitHandlers.fserviceSignupForm (fsCookie - Exception)',
        0,
        exception
      );
    }

    const emailNew = $form.find('.email-form').val();
    if (emailOld === emailNew) {
      uid = uidOld;
    }

    // Set up params for signup request to Fservice backend
    postData.push({
      name: 'user[name]',
      value: firstName
    }, {
      name: 'user[last_name]',
      value: lastName
    }, {
      name: 'user[email]',
      value: emailid
    }, {
      name: 'account[name]',
      value: company
    }, {
      name: 'user[phone]',
      value: phoneNumber || localStorage.getItem('number_given')
    }, {
      name: 'session_json',
      value: sessionJSON
    }, {
      name: 'first_referrer',
      value: (isExternalIframeSignup && currentReferrer) ? currentReferrer : currentLoc
    }, {
      name: 'first_landing_url',
      value: $form.find('input[name^="first_landing_url"]').val()
    }, {
      name: 'noscript',
      value: $form.find('input[name="noscript"]').val()
    }, {
      name: 'pre_visits',
      value: Cookie.get('fw_vi') || 0
    }, {
      name: 'account_timezone_offset',
      value: sessionObj.time.tz_offset
    }, {
      name: 'fd_cid',
      value: uid
    }, {
      name: 'fs_cookie',
      value: fsCookie
    }, {
      name: 'account[lang]',
      value: getSignupEndpointLang(currentLang) || 'en'
    }, {
      name: 'misc[lead_source]',
      value: 'Trial Signup'
    });

    const marketingCampaign = $form.find('[name="MarketingCampaign"],[name="Marketing Campaign"],[name="marketing_campaign"],[name="marketingcampaign"],[name="marketing campaign"]').data('custom-value');

    if (marketingCampaign) {
      postData.push({
        name: 'misc[marketing_campaign]',
        value: marketingCampaign
      });
    }

    if ($form.hasClass('msp-signup-form')) {
      postData.push({
        name: 'account[msp_website_signup]',
        value: 'true'
      }, {
        name: 'utc_offset',
        value: '5.5'
      });
    }

    if ($domainField.length) {
      postData.push({
        name: 'account[domain]',
        value: $domainField.val()
      });
    }

    postData.push({
      name: 'misc[keyword]',
      value: SiteUtilities.getParameterByName('utm_term')
    });

    const souceMedium = channelInfo.fetch();

    if (souceMedium) {
      postData.push({
        name: 'misc[source_medium]',
        value: souceMedium
      });
    }

    if (utmMedium) {
      postData.push({
        name: 'misc[utm_medium]',
        value: utmMedium
      });
    }

    const currentUrlPath = document.URL && new URL(document.URL) ? new URL(document.URL).pathname : '';

    if (currentUrlPath === '/freshservice/msp-signup/') {
      postData.push({
        name: 'cloud_type[name]',
        value: 'ITSM'
      }, {
        name: 'cloud_type[template_type]',
        value: 'it'
      }, {
        name: 'cloud_type[msp]',
        value: 'true'
      });
    }

    if (currentUrlPath === '/freshservice/signup/partners-external-iframe-signup/' || currentUrlPath === '/freshservice/signup/partners-shi/') {
      postData.push({
        name: 'signup_mode',
        value: 'generic'
      });
    }

    if (currentUrlPath === '/freshservice/signup/') {
      const referrerUrlPath = document.referrer && new URL(document.referrer) ? new URL(document.referrer).pathname : '';
      const referrerCode = SiteUtilities.getParameterByName('referrerCode') || '';
      if (referrerCode === 'esm' || referrerUrlPath === '/freshservice/solutions/enterprise-service-management/') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ESM'
        });
      }

      if (referrerCode === 'hr' || referrerUrlPath === '/freshservice/solutions/enterprise-service-management/hr/') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ESM'
        }, {
          name: 'cloud_type[template_type]',
          value: 'hr'
        });
      }

      if (referrerCode === 'facilities' || referrerUrlPath === '/freshservice/solutions/enterprise-service-management/facilities/') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ESM'
        }, {
          name: 'cloud_type[template_type]',
          value: 'facilities'
        });
      }

      if (referrerCode === 'finance' || referrerUrlPath === '/freshservice/solutions/enterprise-service-management/finance/') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ESM'
        }, {
          name: 'cloud_type[template_type]',
          value: 'finance'
        });
      }

      if (referrerCode === 'legal' || referrerUrlPath === '/freshservice/solutions/enterprise-service-management/legal/') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ESM'
        }, {
          name: 'cloud_type[template_type]',
          value: 'legal'
        });
      }

      if (referrerCode === 'marketing' || referrerUrlPath === '/freshservice/solutions/enterprise-service-management/marketing/') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ESM'
        }, {
          name: 'cloud_type[template_type]',
          value: 'marketing'
        });
      }

      if (referrerUrlPath === '/freshservice/pricing/') {
        if (referrerCode === 'it') {
          postData.push({
            name: 'cloud_type[name]',
            value: 'ITSM'
          }, {
            name: 'cloud_type[template_type]',
            value: 'it'
          });
        } else if (referrerCode === 'esm') {
          postData.push({
            name: 'cloud_type[name]',
            value: 'ESM'
          });
        } else {
          postData.push({
            name: 'signup_mode',
            value: 'generic'
          });
        }
      } else if (document.referrer === '') {
        postData.push({
          name: 'cloud_type[name]',
          value: 'ITSM'
        }, {
          name: 'cloud_type[template_type]',
          value: 'it'
        });
      }
    }

    $miscPayload.each((index, ele) => {
      postData.push({
        name: `misc[${$(ele).data('key')}]`,
        value: $(ele).data('value')
      });
    });
    // Post to freshmarketer.
    // Construct freshmarketer object for api submission only on 200 status code
    const freshmarketerData = {
      freshmarketerObject: {
        first_name: firstName,
        last_name: lastName,
        email: emailid,
        phone: phoneNumber,
        company: company,
        country: country || '',
        product: 'fservice',
        // Please dont forget the !
        contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
        custom_field: {
          cf_fservicefirstreferrer: Cookie.get('fw_flu') || '',
          cf_fservicesignupreferrer: window.location.href || '',
          cf_freshmarketer_list: $form.find('.fm-list-id').val()
        },
        composite_stitching_key: compositeKey
      }
    };

    postData.push({
      name: 'misc[collector_details]',
      value: JSON.stringify(SiteUtilities.buildFreshmarketerObject(JSON.parse(JSON.stringify(freshmarketerData)), true, form, false))
    });
    const signupOptions = {
      type: 'POST',
      dataType: 'json',
      url: signUpApiUrl,
      data: postData,
      crossDomain: true
    };
    SiteUtilities.configureAssetId($form, 'fservice');

    // Set up AJAX params for risk score API call
    try {
      spamData = {
        emailAddress: emailid,
        ipAddress: maxmindObj ? maxmindObj.ipAddress : '',
        accountName: company,
        phone: phoneNumber,
        city: maxmindObj ? maxmindObj.cityName : '',
        country: maxmindObj ? maxmindObj.countryName : '',
        firstName: firstName,
        lastName: lastName,
        cache_id: uid,
        website: $form.find('input[name^="first_landing_url"]').val(),
        referrer: $form.find('input[name^="first_referrer"]').val()
      };
      if ($domainField.length) {
        spamData.accountDomain = $domainField.val();
      }
    } catch (e) {}

    var spamOptions = {
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      url: spamCheckUrl,
      data: JSON.stringify(spamData)
    };
    // constructing a separate obj for signuplogs and signup performance logs since the payload is of diff format.
    const payloadData = {
      user: {
        first_name: firstName,
        last_name: lastName,
        email: emailid,
        phone: phoneNumber,
        company_name: company
      },
      session_json: sessionObj
    };
    const signupLogData = {
      email: emailid,
      source: 'FW.Submit.fserviceSignupForm',
      product: 'fservice',
      ip_address: maxmindObj ? maxmindObj.ipAddress : '',
      type: 'signup',
      signup_payload_payload: payloadData,
      api_endpoint: signUpApiUrl
    };
    localStorage.setItem('signupPerformanceLogData', JSON.stringify(signupLogData));
    localStorage.setItem('signupPerformanceProductLabel', 'fservice');
    localStorage.setItem('signupPerformanceSignupUrl', window.location.href);

    if ($form.find('.security-field-wrapper input').val()) {
      try {
        localStorage.setItem('isHoneyPotSignup', 'true');
        SiteUtilities.signupLog(signupLogData, form, null, { message: 'Spam Signup (Honey pot field has been filled)' }, true);
        SiteUtilities.signupPerformanceLog(signupLogData, 'fservice', 'rejected', '400', 'Fservice API call not initiated - Received Honey pot Signup');
        setTimeout(() => {
          window.location.href = redirectSpam || redirect;
        }, 2000);
      } catch (error) {
      }
    } else {
      if (maxmindObj && maxmindObj.ipAddress && maxmindObj.ipAddress.length > 0 && emailOld !== emailNew) {
        let upstreamServiceTime = null;
        emailOld = emailNew;
        uidOld = uid;
        // Make signup, spam score requests and process responses when both are done
        localStorage.setItem('fserviceSignupStartTime', new Date().toISOString());
        $.when(
          $.ajax(signupOptions),
          $.ajax(spamOptions)
        )
          .done(function (signupResponse, spamResponse) {
            upstreamServiceTime = signupResponse[2] && signupResponse[2].getResponseHeader && signupResponse[2].getResponseHeader('X-Envoy-Upstream-Service-Time');
            upstreamServiceTime && localStorage.setItem('upstreamServiceDuration', upstreamServiceTime);
            if (signupResponse[0].success === true && spamResponse[0].statusCode === 200) {
              localStorage.setItem('fserviceSignupEndTime', new Date().toISOString());
              channelInfo.destroy();
              const signupResponseStatusCode = 200;
              SiteUtilities.signupLog(signupLogData, form, signupResponseStatusCode, { message: `Signup API call successful` });
              const spamResponseBody = JSON.parse(spamResponse[0].body);
              const spamScore = spamResponseBody.Results['RISK SCORE'];
              const accountId = signupResponse[0].account_id;
              redirectUrl = signupResponse[0].url;
              // Store redirect URL for redirection to account from thank you page
              SiteUtilities.setFserviceLastAccessedAccountCookie(redirectUrl);
              freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
              freshmarketerData.freshmarketerObject.accountId = accountId;
              freshmarketerData.freshmarketerObject.product = 'Freshservice';
              SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshservice');

              // Storing growsumo data
              var gsdata = {
                first_name: firstName,
                email_id: emailid,
                domain_name: $domainField.val()
              };
              if (!$domainField.val()) {
                gsdata['account_id'] = 'freshservice.' + accountId;
              }
              localStorage.setItem('gsdata', JSON.stringify(gsdata));

              GA4Utilities.fwFormSubmit(classname, { company, email: emailid, firstName, lastName, phone: phoneNumber });

              const redirectURLEncoded = encodeURIComponent(redirectUrl);
              let thankYouRedirect;
              thankYouRedirect = (spamScore <= 4)
                ? `${redirect}/?redirect=${redirectURLEncoded}&aid=${accountId}&ehash=${emailHash}`
                : `${redirectSpam}/?redirect=${redirectURLEncoded}&aid=${accountId}&ehash=${emailHash}`;
              if (isExternalIframeSignup) {
                thankYouRedirect += '&post_to_partner=true';
                if (currentReferrer) {
                  thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
                }
              }
              localStorage.setItem('signupStatusCode', signupResponseStatusCode);
              localStorage.setItem('signupStatusText', 'success');
              localStorage.setItem('signupStatusMsg', 'Freshservice Signup API call successful');

              const growSumoPayload = SiteUtilities.buildGrowSumoPayload('pk_OrZ1wKWPqoR5Rj4K6xgniKy1ATxs9VcX', '');
              const collectorPayload = SiteUtilities.buildFreshmarketerObject(freshmarketerData, false, form, false);
              let admitadOrderId = 'freshservice.' + accountId;
              if ($domainField && $domainField.val()) {
                admitadOrderId = $domainField.val();
              }
              const admitadPayload = SiteUtilities.buildAdmitadPayload(admitadOrderId);

              const awinConversionPayload = getAwinConversionPayload({ product: 'fservice', email: emailid, accountId });

              localStorage.setItem('fmarketerStartTime', new Date().toISOString());
              try {
                SiteUtilities.postToKinesis({ growSumoPost: growSumoPayload, fmCollectorPost: collectorPayload, awinConversionPost: awinConversionPayload, admitadPost: admitadPayload }, true);
                localStorage.setItem('fmarketerEndTime', new Date().toISOString());
              } catch (e) {
                SiteUtilities.log(
                  'Error in Kinesis API Call (Collector + Growsumo)',
                  'error',
                  'fservice-form-handlers.js',
                  1,
                  e
                );
              }
              localStorage.setItem('gtmScriptLoadStartTime', new Date().toISOString());
              jQuery.when(
                loadGtmScriptsOnSignupCompletionAsync(thankYouRedirect)
              ).catch(function (e) {
                SiteUtilities.log(
                  'Error in loading GTM Scripts',
                  'error',
                  'fservice-form-handlers.js',
                  1,
                  e
                );
              }).always(function () {
                localStorage.setItem('gtmScriptLoadEndTime', new Date().toISOString());
                ['gsdata', 'kinesisPost'].forEach((i) => localStorage.removeItem(i));
                SiteUtilities.triggersignupPerformanceLogApi(true);
                SiteUtilities.signupToProductRedirect(redirectUrl, isExternalIframeSignup);
              });
              if (localStorage.getItem('number_given')) {
                localStorage.removeItem('number_given');
              }
              if (localStorage.getItem('expressModalShown')) {
                localStorage.removeItem('expressModalShown');
              }
            } else {
              localStorage.setItem('fserviceSignupEndTime', new Date().toISOString());
              const signUpError = signupResponse[0].success ? 'Freshservice Spam API Error' : 'Freshservice Signup API Error';
              const responseObject = {
                SignupResponse: signupResponse[0],
                SpamResponse: spamResponse[0]
              };
              if (signupResponse[0].success) {
                SiteUtilities.classifyStatusCode(`${signUpError}`, 'fserviceSignupForm', responseObject.SignupResponse);
              }
              if (signupResponse[0].errors) {
                // log all signup errors except "Domain is not available" error.
                if (signUpError === 'Freshservice Signup API Error' && signupResponse[0].errors[0][1] && signupResponse[0].errors[0][1] !== 'Domain is not available!') {
                  SiteUtilities.classifyStatusCode(spamResponse[0].statusCode, `${signUpError}`, 'fserviceSignupForm', responseObject.SpamResponse);
                }
                $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
                const domainError = JSON.parse(signupResponse[0].errors);
                $form.find('.backend-error-wrapper').html(domainError[0][1]);
              }
              signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
              GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
              SiteUtilities.signupLog(signupLogData, form, signupResponse[0].statusCode, { message: `Aloha v2 Signup API call succeeded - ${signUpError}`, error: `${responseObject.SignupResponse || 'jqXHR response text is undefined'}` });
              SiteUtilities.signupPerformanceLog(signupLogData, 'fservice', 'error', signupResponse[0].statusCode, 'Freshservice Signup API call succeeded - Received Error Response');
            }
          })
          .fail((jqXHR, textStatus, errorThrown) => {
            localStorage.setItem('fserviceSignupEndTime', new Date().toISOString());
            upstreamServiceTime = jqXHR.getResponseHeader('X-Envoy-Upstream-Service-Time');
            upstreamServiceTime && localStorage.setItem('upstreamServiceDuration', upstreamServiceTime);

            const responseObject = {
              jqXHR,
              textStatus,
              errorThrown
            };
            SiteUtilities.setBackendErrorMessage($form, jqXHR.status, 'fservice');
            SiteUtilities.classifyStatusCode(jqXHR.status, `Freshservice Signup API call failed. StatusCode: ${jqXHR.status}`, 'fserviceSignupForm', responseObject);
            signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
            GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
            SiteUtilities.signupLog(signupLogData, form, jqXHR.status, { message: `Freshservice Signup API call failed`, error: `${jqXHR.responseText || 'jqXHR response text is undefined'}`, textStatus: `${textStatus}` });
            SiteUtilities.signupPerformanceLog(signupLogData, 'fservice', textStatus, jqXHR.status, 'Freshservice Signup API call failed');
          });
      } else {
        let upstreamServiceTime = null;
        localStorage.setItem('fserviceSignupStartTime', new Date().toISOString());
        $.ajax(signupOptions)
          .done(function (signupResponse, status, jqXHR) {
            upstreamServiceTime = jqXHR.getResponseHeader('X-Envoy-Upstream-Service-Time');
            upstreamServiceTime && localStorage.setItem('upstreamServiceDuration', upstreamServiceTime);
            if (signupResponse.success) {
              const signupResponseStatusCode = 200;
              localStorage.setItem('fserviceSignupEndTime', new Date().toISOString());
              const accountId = signupResponse.account_id;
              redirectUrl = signupResponse.url;
              SiteUtilities.setFserviceLastAccessedAccountCookie(redirectUrl);
              freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
              freshmarketerData.freshmarketerObject.accountId = accountId;
              freshmarketerData.freshmarketerObject.product = 'Freshservice';
              SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshservice');
              GA4Utilities.fwFormSubmit(classname, { company, email: emailid, firstName, lastName, phone: phoneNumber });

              const redirectURLEncoded = encodeURIComponent(redirectUrl);
              let thankYouRedirect;
              thankYouRedirect = `${redirect}/?redirect=${redirectURLEncoded}&aid=${accountId}&ehash=${emailHash}`;
              if (isExternalIframeSignup) {
                thankYouRedirect += '&post_to_partner=true';
                if (currentReferrer) {
                  thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
                }
              }
              localStorage.setItem('signupStatusCode', signupResponseStatusCode);
              localStorage.setItem('signupStatusText', 'success');
              localStorage.setItem('signupStatusMsg', 'Freshservice Signup API call successful');

              const growSumoPayload = SiteUtilities.buildGrowSumoPayload('pk_OrZ1wKWPqoR5Rj4K6xgniKy1ATxs9VcX', '');
              const collectorPayload = SiteUtilities.buildFreshmarketerObject(freshmarketerData, false, form, false);
              let admitadOrderId = 'freshservice.' + accountId;
              if ($domainField && $domainField.val()) {
                admitadOrderId = $domainField.val();
              }
              const admitadPayload = SiteUtilities.buildAdmitadPayload(admitadOrderId);

              const awinConversionPayload = getAwinConversionPayload({ product: 'fservice', email: emailid, accountId });
              localStorage.setItem('fmarketerStartTime', new Date().toISOString());
              try {
                SiteUtilities.postToKinesis({ growSumoPost: growSumoPayload, fmCollectorPost: collectorPayload, awinConversionPost: awinConversionPayload, admitadPost: admitadPayload }, true);
                localStorage.setItem('fmarketerEndTime', new Date().toISOString());
              } catch (e) {
                SiteUtilities.log(
                  'Error in Kinesis API Call (Collector + Growsumo)',
                  'error',
                  'fservice-form-handlers.js',
                  1,
                  e
                );
              }
              localStorage.setItem('gtmScriptLoadStartTime', new Date().toISOString());
              jQuery.when(
                loadGtmScriptsOnSignupCompletionAsync(thankYouRedirect)
              ).catch(function (e) {
                SiteUtilities.log(
                  'Error in loading GTM Scripts',
                  'error',
                  'fservice-form-handlers.js',
                  1,
                  e
                );
              }).always(function () {
                localStorage.setItem('gtmScriptLoadEndTime', new Date().toISOString());
                ['gsdata', 'kinesisPost'].forEach((i) => localStorage.removeItem(i));
                SiteUtilities.triggersignupPerformanceLogApi(true);
                SiteUtilities.signupToProductRedirect(redirectUrl, isExternalIframeSignup);
              });

              if (localStorage.getItem('number_given')) {
                localStorage.removeItem('number_given');
              }
              if (localStorage.getItem('expressModalShown')) {
                localStorage.removeItem('expressModalShown');
              }
            } else {
              localStorage.setItem('fserviceSignupEndTime', new Date().toISOString());
              if (signupResponse.errors) {
                if (signupResponse.errors[0][1] && signupResponse.errors[0][1] !== 'Domain is not available!') {
                  const responseObject = {
                    SignupResponse: signupResponse
                  };
                  SiteUtilities.classifyStatusCode('Freshservice Signup API call succeeded - received error response', 'fserviceSignupForm - succeeded .done (Maxmind unavailable)', responseObject);
                }
                $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
                const domainError = JSON.parse(signupResponse.errors);
                $form.find('.backend-error-wrapper').html(domainError[0][1]);
              }
              signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
              GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
              SiteUtilities.signupLog(signupLogData, form, signupResponse.statusCode, { message: `Freshservice Signup API call succeeded - received error response`, error: `${signupResponse || 'jqXHR response text is undefined'}` });
              SiteUtilities.signupPerformanceLog(signupLogData, 'fservice', 'error', signupResponse.statusCode, 'Freshservice Signup API call succeeded - received error response');
            }
          })
          .fail((jqXHR, textStatus, errorThrown) => {
            localStorage.setItem('fserviceSignupEndTime', new Date().toISOString());
            upstreamServiceTime = jqXHR.getResponseHeader('X-Envoy-Upstream-Service-Time');
            upstreamServiceTime && localStorage.setItem('upstreamServiceDuration', upstreamServiceTime);
            const responseObject = {
              jqXHR,
              textStatus,
              errorThrown
            };
            SiteUtilities.setBackendErrorMessage($form, jqXHR.status, 'fservice');
            SiteUtilities.classifyStatusCode(jqXHR.status, 'Freshservice Signup API call failed', 'fserviceSignupForm', responseObject);
            signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
            GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
            SiteUtilities.signupLog(signupLogData, form, jqXHR.status, { message: `Freshservice Signup API call failed`, error: `${jqXHR.responseText || 'jqXHR response text is undefined'}`, textStatus: `${textStatus}` });
            SiteUtilities.signupPerformanceLog(signupLogData, 'fservice', textStatus, jqXHR.status, 'Freshservice Signup API call failed');
          });
      }
    }
  };
  /* checking multiple conditions to show modal
    1. if the phone number is given while filling the signup form
    2. if this form should have the express check
    3. if the expressModalShown already but signup did not happen due to domain check error (if already shown no need to show again)
  */
  if (phoneNumber.length === 0 && !isNumberGiven && phoneCheck === 'phone' && !expressModalShown) {
    const $phoneNumberForm = $form.siblings('#phone-modal');
    /*
      putting user name in the expressModal heading.
      checking the gdpr checkbox in both expressModal and Signup form and Checking the other based on the other
    */
    try {
      const $heading = $phoneNumberForm.find('.modal-heading'); // popup heading
      $heading.text($heading.text().replace(/<<NAME>>/i, $form.find('input[name^="first-name"]').val()));
      if ($form.find('input[name="send_promotions"]').is(':checked') && !$phoneNumberForm.find('input[name="send_promotions"]').is(':checked')) {
        $phoneNumberForm.find('input[name="send_promotions"]').click();
      }
    } catch (e) {}

    /* If the sign up form is present inside a modal box in that
       case the express modal overlaps with the signup modal
    */
    if (isParentModal) {
      $form.hide();
      $form.siblings('.form-heading-text').hide();
      $phoneNumberForm.show();
      // when the phoneNumberForm is shown and the user click outside of form by mistake which closed the modal, so showing it again to complete signup
      $form.closest('#' + parentModalId).on('hide.bs.modal', function (e) {
        // perventing the modal to hide if user click outside the modal by mistake, showing the sign up modal
        e.preventDefault();
        $form.siblings('.form-heading-text').show();
        $form.show();
        $phoneNumberForm.hide();
        localStorage.setItem('expressModalShown', true);
        signupFlow();
      });
      // showing the signup form again if the user give the phone number
      $phoneNumberForm.on('expressNumberGiven', function () {
        $phoneNumberForm.hide();
        $form.siblings('.form-heading-text').show();
        $form.show();
        signupFlow();
      });
    } else { // when the signup form is present directly on the page
      $phoneNumberForm.modal('show');
      $phoneNumberForm.on('hidden.bs.modal', function () {
        signupFlow();
      });
    }
  } else {
    signupFlow();
  }

  if (!SiteUtilities.canIUseSendBeacon()) {
    SiteUtilities.makePreflightRequest('https://alfred.freshworks.com/v1/kinesis-post');
  }
  SiteUtilities.makePreflightRequest('https://alfred.freshworks.com/v1/signup-performance-log');
};

const fserviceDemoRequestForm = (classname, form) => {
  const $form = $(form);
  $('form').find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const emailid = $form.find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const firstName = $form.find('.first-name-form').val();
  const lastName = $form.find('.last-name-form').val();
  const companyName = $form.find('.company-form').val();
  const phone = $form.find('.phone-form').val();
  const geoLocation = LocationUtilities.getGeoLocation();
  const country = geoLocation ? geoLocation.countryName : '';
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: emailid,
      company: companyName,
      country: country || '',
      phone: phone,
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fserviceagentcount: $form.find('input.employees-form').val(),
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };

  setTimeout(function () {
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.location.href = $form.attr('data-redirect') + `/?ehash=${emailHash}`;
    }, (err) => {
      SiteUtilities.log(
        'Freshsales identity lead creation failure',
        'error',
        'freshservice.fserviceDemoRequestForm',
        2, err
      );
    });
  }, 500);
};

const fserviceEmailOnlySignupForm = function (classname, form) {
  const $form = $(form);
  const customEndpoint = $form.attr('data-custom-endpoint');
  let signUpApiUrl = $form.data('signup-url') || 'https://signup.freshservice.com/accounts/email_only_signup';
  if (customEndpoint) {
    signUpApiUrl = customEndpoint;
  }
  const spamCheckUrl = $form.data('spam-check-url') || 'https://alfred.freshworks.com/v1/robin';
  let postData = [];
  let spamData = {};
  let redirectUrl = '#';
  let currentLoc = '';
  const $signUpBtn = $form.find('input.button');
  const buttonValue = $signUpBtn.val();
  let uid = SiteUtilities.generateUID();
  const redirect = $form.attr('data-redirect');
  const redirectSpam = $form.attr('data-redirect-spam');
  const emailid = $form.find('.email-fservice').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const currentLang = $('body').data('lang');
  // Populate hidden fields with cookie info
  $signUpBtn.addClass('button--loading').attr('disabled', 'disabled');
  $form.find('input[name^="first_referrer"]').val((Cookie.get('fw_fr') || currentLoc));
  $form.find('input[name^="first_landing_url"]').val((Cookie.get('fw_flu') || ''));

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(emailid, fmAssetId, tacticId);
  const gclid = SiteUtilities.getGclId();

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = SiteUtilities.getCombinedGaClientId(gclid, compositeKey);
  }

  // Binding maxmind_session
  sessionObj.location = LocationUtilities.getGeoLocation();
  const maxmindObj = LocationUtilities.getGeoLocation();
  const country = maxmindObj ? maxmindObj.countryName : '';
  currentLoc = (sessionObj && sessionObj.original_session) ? sessionObj.original_session.referrer : SiteUtilities.getCurrentLocation();
  if (currentReferrer && isExternalIframeSignup) {
    currentLoc = currentReferrer;
    sessionObj.current_session.url = `${SiteUtilities.getCurrentLocation()}?first_referrer=${currentReferrer}`;
  }
  if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
    const { simpleGeoLocation: { countryCode, countryName, country: { iso_code: isoCode } = {} } = {} } = sessionObj || {};
    if (sessionObj) {
      sessionObj.location = {
        country: {
          iso_code: isoCode || ''
        },
        ipAddress: '',
        countryCode: countryCode || '',
        countryName: countryName || ''
      };
      sessionObj.simpleGeoLocation = sessionObj.location;
      sessionObj.geoLocation = sessionObj.location;
    }
  }

  if (sessionObj) {
    // attach Google click ID (gclid) in sessionObj
    sessionObj.gclid = gclid;
  }

  const sessionJSON = sessionObj ? JSON.stringify(sessionObj) : null;

  // Bind username and fs_cookie
  let fsCookie = '';
  try {
    fsCookie = freshsales.anonymous_id;
  } catch (exception) {
    SiteUtilities.log(
      'Freshservice session exception.',
      'warning',
      'submitHandlers.fserviceEmailOnlySignupForm (fsCookie - Exception)',
      0,
      exception
    );
  }

  const emailNew = $form.find('.email-fservice').val();
  if (emailOld === emailNew) {
    uid = uidOld;
  }

  // Set up params for signup request to Fservice backend
  postData = {
    account: { lang: getSignupEndpointLang(currentLang) || 'en' },
    user: { email: $form.find('.email-fservice').val() },
    session_json: sessionJSON,
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : currentLoc,
    first_landing_url: $form.find('input[name="first_landing_url"]').val(),
    first_search_engine: sessionObj.original_session.search.engine,
    first_search_query: sessionObj.original_session.search.query,
    pre_visits: sessionObj.original_session.visits,
    fd_cid: uid,
    fs_cookie: fsCookie,
    signup_button: buttonValue
  };

  const signupOptions = {
    type: 'POST',
    dataType: 'json',
    url: signUpApiUrl,
    data: postData,
    crossDomain: true
  };
  SiteUtilities.configureAssetId($form, 'fservice');
  // Post to freshmarketer.
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      email: $form.find('.email-fservice').val(),
      country: country || '',
      // Please dont forget the !
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fservicefirstreferrer: Cookie.get('fw_flu') || '',
        cf_fservicesignupreferrer: window.location.href || '',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      composite_stitching_key: compositeKey
    }
  };

  // Set up AJAX params for risk score API call
  try {
    spamData = {
      emailAddress: $form.find('.email-fservice').val(),
      ipAddress: maxmindObj ? maxmindObj.ipAddress : '',
      city: maxmindObj ? maxmindObj.cityName : '',
      country: maxmindObj ? maxmindObj.countryName : '',
      cache_id: uid,
      website: $form.find('input[name^="first_landing_url"]').val(),
      referrer: $form.find('input[name^="first_referrer"]').val()
    };
  } catch (e) {}

  const spamOptions = {
    type: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    url: spamCheckUrl,
    data: JSON.stringify(spamData)
  };
  if (maxmindObj && maxmindObj.ipAddress && maxmindObj.ipAddress.length > 0 && emailOld !== emailNew) {
    emailOld = emailNew;
    uidOld = uid;
    // Make signup, spam score requests and process responses when both are done
    $.when(
      $.ajax(signupOptions),
      $.ajax(spamOptions)
    )
      .done(function (signupResponse, spamResponse) {
        if (signupResponse[0].success === true && spamResponse[0].statusCode === 200) {
          const spamResponseBody = JSON.parse(spamResponse[0].body);
          const spamScore = spamResponseBody.Results['RISK SCORE'];
          const accountId = signupResponse[0].account_id;
          redirectUrl = signupResponse[0].url;
          // Store redirect URL for redirection to account from thank you page
          localStorage.setItem('redirect_url', redirectUrl);
          freshmarketerData.freshmarketerObject.product = 'Freshservice';
          freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
          freshmarketerData.freshmarketerObject.accountId = accountId;

          GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
          SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshservice');
          // Store spam score to pass to GTM
          localStorage.setItem('risk_score', spamScore);
          jQuery.when(
            SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
          ).then(function () {
            jQuery('body').trigger('trackingCompleted');
          });
          // Storing growsumo data
          const gsdata = {
            email_id: $form.find('.email-fservice').val()
          };
          localStorage.setItem('gsdata', JSON.stringify(gsdata));
          GA4Utilities.fwFormSubmit(classname, { email: emailid });
          jQuery('body').on('trackingCompleted', () => {
            setTimeout(() => {
              const redirectURLEncoded = encodeURIComponent(redirectUrl);
              let thankYouRedirect = (spamScore <= 4)
                ? `${redirect}/?redirect=${redirectURLEncoded}&aid=${accountId}&ehash=${emailHash}`
                : `${redirectSpam}/?redirect=${redirectURLEncoded}&aid=${accountId}&ehash=${emailHash}`;
              if (isExternalIframeSignup) {
                thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
                if (currentReferrer) {
                  thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
                }
              }
              window.location.href = thankYouRedirect;
            }, 500);
          });
        } else {
          const signUpError = signupResponse[0].success ? 'Freshservice Spam API Error' : 'Freshservice Email Only Signup API Error';
          const responseObject = {
            SignupResponse: signupResponse[0],
            SpamResponse: spamResponse[0]
          };
          if (signupResponse[0].success) {
            SiteUtilities.classifyStatusCode(`${signUpError}`, 'fserviceEmailOnlySignupForm', responseObject.SignupResponse);
          }
          if (signupResponse[0].errors) {
          // log all signup errors except "Domain is not available" error.
            if (signUpError === 'Freshservice Email Only Signup API Error' && signupResponse[0].errors[0][1] && signupResponse[0].errors[0][1] !== 'Domain is not available!') {
              SiteUtilities.classifyStatusCode(spamResponse[0].statusCode, `${signUpError}`, 'fserviceEmailOnlySignupForm', responseObject.SpamResponse);
            }
            $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
            const domainError = JSON.parse(signupResponse[0].errors);
            $form.find('.backend-error-wrapper').html(domainError[0][1]);
          }
          $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
          GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
          $form.find('.email-field').addClass('error').find('.error-wrapper').html('<em class="error">' + signupResponse[0].errors[0] + '</em>');
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const responseObject = {
          jqXHR,
          textStatus,
          errorThrown
        };
        SiteUtilities.classifyStatusCode(jqXHR.status, `Freshservice Signup API call failed. StatusCode: ${jqXHR.status}`, 'fserviceEmailOnlySignupForm', responseObject);
        $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
      });
  } else {
    $.ajax(signupOptions)
      .done(function (signupResponse) {
        if (signupResponse.success) {
          const accountId = signupResponse.account_id;
          redirectUrl = signupResponse.url;
          localStorage.setItem('redirect_url', redirectUrl);
          freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
          freshmarketerData.freshmarketerObject.accountId = accountId;
          freshmarketerData.freshmarketerObject.product = 'Freshservice';
          GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
          SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshservice');
          jQuery.when(
            SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
          ).then(function () {
            jQuery('body').trigger('trackingCompleted');
          });
          GA4Utilities.fwFormSubmit(classname, { email: emailid });
          jQuery('body').on('trackingCompleted', () => {
            setTimeout(() => {
              const redirectURLEncoded = encodeURIComponent(redirectUrl);
              let thankYouRedirect = `${redirect}/?redirect=${redirectURLEncoded}&aid=${accountId}&ehash=${emailHash}`;
              if (isExternalIframeSignup) {
                thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
              }
              window.location.href = thankYouRedirect;
            }, 500);
          });
        } else {
          if (signupResponse.errors) {
            if (signupResponse.errors[0][1] && signupResponse.errors[0][1] !== 'Domain is not available!') {
              const responseObject = {
                SignupResponse: signupResponse
              };
              SiteUtilities.classifyStatusCode('Freshservice Signup API call succeeded - received error response', 'fserviceEmailOnlySignupForm - succeeded .done (Maxmind unavailable)', responseObject);
            }
            $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
            const domainError = JSON.parse(signupResponse.errors);
            $form.find('.backend-error-wrapper').html(domainError[0][1]);
          }
          $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
          GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const responseObject = {
          jqXHR,
          textStatus,
          errorThrown
        };
        SiteUtilities.classifyStatusCode(jqXHR.status, 'Freshservice Signup API call failed', 'fserviceEmailOnlySignupForm', responseObject);
        $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
      });
  }
};

const fserviceLoginForm = function (classname, form) {
  const $form = $(form);
  const domainForm = $form.find('input.domain-form');
  const domain = domainForm.val();
  domainForm.parents('.form-field').removeClass('error');
  window.location.href = 'https://' + domain + '.freshservice.com';
  GA4Utilities.loginFormSubmit(domain);
};

const fserviceForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const emailForm = $form.find('.email-form');
  const email = emailForm.val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://app.freshservice.com/search_user_domain.json';
  const settings = {
    async: false,
    crossDomain: true,
    url: forgotDomainUrl,
    type: 'GET',
    data: {
      user_email: email,
      global: true
    }
  };
  jQuery.ajax(settings).done(function (data, textStatus, jqXHR) {
    if (data.available) {
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    } else {
      const errorMessage = "<em class='error'>This email does not exist</em>";
      emailForm.parents('.form-field').addClass('error').find('.error-wrapper').empty().append(errorMessage);
    }
  }).fail(function () {
    const errorMessage = "<em class='error'>Error contacting the API</em>";
    emailForm.parents('.form-field').addClass('error').find('.error-wrapper').empty().append(errorMessage);
  });
};

export default {
  fserviceSignupForm,
  fserviceLoginForm,
  fserviceForgotDomainForm,
  fserviceDemoRequestForm,
  fserviceEmailOnlySignupForm
};
